/**
* 成本
*/
const cost = {
  
addCompanyPricingModeOfEnergyCost: "/api/addCompanyPricingModeOfEnergyCost",//添加能源能源计价方式
getCompanyPricingModeOfEnergyCost: "/api/getCompanyPricingModeOfEnergyCost",//查询能源计价方式
modifyCompanyPricingModeOfEnergyCost: "/api/modifyCompanyPricingModeOfEnergyCost",//修改能源计价方式
deleteCompanyPricingModeOfEnergyCost: "/api/deleteCompanyPricingModeOfEnergyCost",//删除能源计价方式
modifyPricingModelParams: "/api/modifyPricingModelParams",//修改计价模型参数
getSpentMoney: "/api/getSpentMoney",//查询成本
getSpentMoneyHour: "/api/getSpentMoneyHour",//查询成本
getSpentMoneyMonth: "/api/getSpentMoneyMonth",//查询成本
getSpentMoneyYear: "/api/getSpentMoneyYear",//查询成本
getSpentMoneyHour2: "/api/getSpentMoneyHour2",//查询成本
getSpentMoneyMonth2: "/api/getSpentMoneyMonth2",//查询成本
getSpentMoneyYear2: "/api/getSpentMoneyYear2",//查询成本
getSpentMoneyHour3: "/api/getSpentMoneyHour3",//查询成本
getSpentMoneyMonth3: "/api/getSpentMoneyMonth3",//查询成本
getSpentMoneyYear3: "/api/getSpentMoneyYear3",//查询成本
getSpentMoneyDay: "/api/getSpentMoneyDay",//查询成本
getSpentMoneyWeek: "/api/getSpentMoneyWeek",//查询成本
getSpentMoneyDay2: "/api/getSpentMoneyDay2",//查询成本
getSpentMoneyWeek2: "/api/getSpentMoneyWeek2",//查询成本
getSpentMoneyDay3: "/api/getSpentMoneyDay3",//查询成本
getSpentMoneyWeek3: "/api/getSpentMoneyWeek3",//查询成本
getSpentMoneyDay4: "/api/getSpentMoneyDay4",//查询成本
getSpentMoneyWeek4: "/api/getSpentMoneyWeek4",//查询成本
getSpentMoneyDay5: "/api/getSpentMoneyDay5",//查询成本
getSpentMoneyWeek5: "/api/getSpentMoneyWeek5",//查询成本
}

export default cost